/*
 * @Description: pageDisplay 组件
 * @Version: V1.0.0
 * @Author: biao_liu@foxitsoftware.com
 * @Date: 2021-07-22 13:26:49
 * @LastEditors: biao_liu@foxitsoftware.com
 * @LastEditTime: 2021-11-30 13:48:02
 */
import './index.scss';
import React, { Component } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Select, Checkbox, InputNumber, Input, Dropdown, Menu } from 'antd';
import intl from 'react-intl-universal';
const { Item } = Form;
const { Option } = Select;
export default class PageDisplay extends Component {
    static storageKey () {
        return 'PAGE_DISPLAY_DATA';
    }
    constructor(props) {
        super(props);
        const fitWidth = intl.formatMessage(
            {
                id: `Preferences.Content.pageDisplay.layoutAndZoom.zoom.options.fitWidth`
            }
        );
        const lang = localStorage.getItem('language');
        let labelCol = 7;
        switch (lang) {
            case 'zh-CN':
                labelCol = 7;
                break;
            case 'en-US':
                labelCol = 7;
                break;
            case 'ja-JP':
                labelCol = 11;
                break;
            case 'de-DE':
                labelCol = 13;
                break;
            case 'fr-FR':
                labelCol = 10;
                break;
            case 'it-IT':
                labelCol = 11;
                break;
            default:
                labelCol = 7;
                break;
        }
        this.state = {
            lang,
            labelCol,
            navigationTabOption: {
                active: 'useInitialView',
                data: [
                    'useInitialView',
                    'pageOnly',
                    'bookmarksPanelAndPage',
                    'pagesPanelAndPage',
                    'attachmentsPanelAndPage',
                    'layersPanelAndPage'
                ]
            },
            defaultPageLayoutOption: {
                active: 'continuous',
                data: [
                    'autoMatic',
                    'singlePage',
                    'continuous',
                    'facing',
                    'continuous-Facing'
                ]
            },
            prevZoom: fitWidth,
            zoomOption: {
                active: 'fitWidth',
                value: fitWidth,
                intlData: [
                    'autoMatic',
                    'actualSize',
                    'fitPage',
                    'fitWidth',
                    'fitVisible'
                ],
                data: [
                    '1',
                    '8.33',
                    '12.5',
                    '25',
                    '33.33',
                    '50',
                    '66.67',
                    '75',
                    '100',
                    '125',
                    '150',
                    '200',
                    '300',
                    '400',
                    '600',
                    '800',
                    '1200',
                    '1600',
                    '3200',
                    '6400'
                ]
            },
            customFacingChecked: false,
            facingPages: 2,
            customMarginChecked: false,
            margin: 8,
            smoothTextOption: {
                active: 'forLaptop_LCDScreens',
                data: [
                    'forLaptop_LCDScreens',
                    'monitor',
                    'none'
                ]
            },
            smoothLineArtChecked: true,
            enhanceThinLinesChecked: true,
            transparencyGridChecked: false,
            logicalPageNumChecked: true
        };
        this.handleChangeNavigation = this.handleChangeNavigation.bind(this);
        this.handleChangDefaultPageLayout = this.handleChangDefaultPageLayout.bind(this);
        this.onChangeCustomFacing = this.onChangeCustomFacing.bind(this);
        this.onChangeCustomMarginChecked = this.onChangeCustomMarginChecked.bind(this);
        this.onChangeCustomMargin = this.onChangeCustomMargin.bind(this);
        this.onChangSmoothText = this.onChangSmoothText.bind(this);
        this.onChangeSmoothLineArt = this.onChangeSmoothLineArt.bind(this);
        this.onChangeTransparencyGrid = this.onChangeTransparencyGrid.bind(this);
        this.onChangeLogicalPageNum = this.onChangeLogicalPageNum.bind(this);
        this.blurZoom = this.blurZoom.bind(this);
        this.selectZoomOption = this.selectZoomOption.bind(this);
        this.changeZoom = this.changeZoom.bind(this);
        this.onChangeFacingPages = this.onChangeFacingPages.bind(this);
    }
    storageFormData = () => {
        const pageDisplayPreferences = {
            navigation: this.state.navigationTabOption.active,
            defaultPageLayout: this.state.defaultPageLayoutOption.active,
            zoom: this.state.zoomOption.active,
            customFacingChecked: this.state.customFacingChecked,
            facingPages: this.state.facingPages,
            customMarginChecked: this.state.customMarginChecked,
            margin: this.state.margin,
            smoothText: this.state.smoothTextOption.active,
            smoothLineArtChecked: this.state.smoothLineArtChecked,
            enhanceThinLinesChecked: this.state.enhanceThinLinesChecked,
            transparencyGridChecked: this.state.transparencyGridChecked,
            logicalPageNumChecked: this.state.logicalPageNumChecked
        };
        localStorage.setItem(PageDisplay.storageKey(), JSON.stringify(pageDisplayPreferences));
    }
    resetStateFromStorage = () => {
        let state = localStorage.getItem(PageDisplay.storageKey());
        if (state) {
            const pageDisplayPreferences = JSON.parse(state);
            const navigationTabOption = Object.assign(this.state.navigationTabOption, { active: pageDisplayPreferences.navigation });
            const defaultPageLayoutOption = Object.assign(
                this.state.defaultPageLayoutOption,
                { active: pageDisplayPreferences.defaultPageLayout });
            const smoothTextOption = Object.assign(this.state.smoothTextOption, { active: pageDisplayPreferences.smoothText });
            this.setState({
                navigationTabOption,
                defaultPageLayoutOption,
                customFacingChecked: pageDisplayPreferences.customFacingChecked,
                facingPages: pageDisplayPreferences.facingPages,
                customMarginChecked: pageDisplayPreferences.customMarginChecked,
                margin: pageDisplayPreferences.margin,
                smoothTextOption,
                smoothLineArtChecked: pageDisplayPreferences.smoothLineArtChecked,
                enhanceThinLinesChecked: pageDisplayPreferences.enhanceThinLinesChecked,
                transparencyGridChecked: pageDisplayPreferences.transparencyGridChecked,
                logicalPageNumChecked: pageDisplayPreferences.logicalPageNumChecked
            });
            // 单独设置 zoomOption
            let zoomVal = pageDisplayPreferences.zoom;
            if (this.state.zoomOption.intlData.includes(zoomVal)) {
                zoomVal = intl.formatMessage(
                    {
                        id: `Preferences.Content.pageDisplay.layoutAndZoom.zoom.options.${zoomVal}`
                    }
                );
            }
            const zoomOption = Object.assign(
                this.state.zoomOption,
                {
                    value:  zoomVal
                });
            this.setState({zoomOption});
            this.checkZoom();
        }
    }
    handleChangeNavigation(val) {
        const active = val;
        const obj = Object.assign(this.state.navigationTabOption, {active});
        this.setState({
            navigationTabOption: obj
        });
    }
    handleChangDefaultPageLayout(val) {
        const active = val;
        const obj = Object.assign(this.state.defaultPageLayoutOption, {active});
        this.setState({
            defaultPageLayoutOption: obj
        });
    }
    selectZoomOption(ev) {
        const active = this.state.zoomOption.intlData.includes(ev.item.props.value) ? ev.item.props.value : +ev.item.props.value;
        const obj = Object.assign(this.state.zoomOption, { active, value: ev.item.props.children });
        const state = {
            zoomOption: obj,
            prevZoom: this.state.zoomOption.value
        };
        this.setState(state);
    }
    changeZoom(e) {
        const obj = Object.assign(this.state.zoomOption, { value: e.target.value });
        this.setState({
            zoomOption: obj
        });
    }
    blurZoom() {
        this.checkZoom();
    }
    checkZoom() {
        let zoom = this.state.zoomOption.value;
        const intlDataOption = this.state.zoomOption.intlData.map(item => intl.formatMessage(
            {
                id: `Preferences.Content.pageDisplay.layoutAndZoom.zoom.options.${item}`
            }
        ));
        const zoomOption = intlDataOption.concat(this.state.zoomOption.data.map(item => item + '%'));
        if (zoomOption.includes(zoom)) {
            const value = zoom;
            const active = this.state.zoomOption.intlData.concat(this.state.zoomOption.data)[zoomOption.indexOf(zoom)];
            const obj = Object.assign({}, this.state.zoomOption, { active, value });
            this.setState({
                zoomOption: obj,
                prevZoom: value
            });
        } else {
            // 如果小数部分保留2位小数
            zoom = Math.round(parseFloat(zoom) * 100) / 100;
            let active;
            let value;
            if (zoom >= 1 && zoom <= 6400) {
                active = zoom;
                value = zoom;
                this.setState({
                    prevZoom: zoom
                });
            } else {
                value = this.state.prevZoom;
                if (zoomOption.includes(value)) {
                    active = this.state.zoomOption.intlData.concat(this.state.zoomOption.data)[zoomOption.indexOf(value)];
                } else {
                    active = value;
                }
                this.setState({
                    prevZoom: value
                });
            }
            if (!intlDataOption.includes(value) && !/%$/.test(value)) {
                value += '%';
            }
            const obj = Object.assign({}, this.state.zoomOption, { active, value });
            this.setState({
                zoomOption: obj
            });
        }
    }
    onChangeCustomFacing(e) {
        this.setState({
            customFacingChecked: e.target.checked
        });
    }
    onChangeFacingPages(val) {
        const facingPages = parseInt(val, 10);
        this.setState({
            facingPages: facingPages
        });
    }
    onChangeCustomMarginChecked(e) {
        this.setState({
            customMarginChecked: e.target.checked
        });
    }
    onChangeCustomMargin(val) {
        const margin = parseInt(val, 10);
        this.setState({
            margin
        });
    }
    onChangSmoothText(val) {
        const obj = Object.assign(this.state.smoothTextOption, { active: val });
        this.setState({
            smoothTextOption: obj
        });
    }
    onChangeSmoothLineArt(e) {
        this.setState({
            smoothLineArtChecked: e.target.checked
        });
    }
    onChangeTransparencyGrid(e) {
        this.setState({
            transparencyGridChecked: e.target.checked
        });
    }
    onChangeLogicalPageNum(e) {
        this.setState({
            logicalPageNumChecked: e.target.checked
        });
    }
    UNSAFE_componentWillMount() {
        this.resetStateFromStorage();
        // setTimeout(() => {
        //     this.storageFormData();
        // });
    }
    render() {
        const me = this;
        const {
            labelCol,
            navigationTabOption,
            defaultPageLayoutOption,
            zoomOption,
            customFacingChecked,
            facingPages,
            customMarginChecked,
            margin,
            smoothTextOption,
            smoothLineArtChecked,
            enhanceThinLinesChecked,
            transparencyGridChecked,
            logicalPageNumChecked
        } = this.state;
        const layoutAndZoomTitle = intl.formatMessage({ id: 'Preferences.Content.pageDisplay.layoutAndZoom.title' });
        const navigationTabName = intl.formatMessage({ id: 'Preferences.Content.pageDisplay.layoutAndZoom.navigationTab.label' });
        const defaultPageLayoutName = intl.formatMessage({ id: 'Preferences.Content.pageDisplay.layoutAndZoom.defaultPageLayout.label' });
        const zoomOptionName = intl.formatMessage({ id: 'Preferences.Content.pageDisplay.layoutAndZoom.zoom.label' });
        const customFacingName = intl.formatMessage({ id: 'Preferences.Content.pageDisplay.layoutAndZoom.customFacing.label' });
        const customMarginName = intl.formatMessage({ id: 'Preferences.Content.pageDisplay.layoutAndZoom.customMargin.label' });
        const renderingTitle = intl.formatMessage({ id: 'Preferences.Content.pageDisplay.rendering.title' });
        const smoothTextName = intl.formatMessage({ id: 'Preferences.Content.pageDisplay.rendering.smoothText.label' });
        const smoothLineArt = intl.formatMessage({ id: 'Preferences.Content.pageDisplay.rendering.smoothLineArt' });
        const enhanceThinLinesText = intl.formatMessage({ id: 'Preferences.Content.pageDisplay.rendering.enhanceThinLines' });
        const pageContentTitle = intl.formatMessage({ id: 'Preferences.Content.pageDisplay.pageContent.title' });
        const transparencyGrid = intl.formatMessage({ id: 'Preferences.Content.pageDisplay.pageContent.transparencyGrid' });
        const logicalPageNum = intl.formatMessage({ id: 'Preferences.Content.pageDisplay.pageContent.logicalPageNum' });
        function dataSource() {
            const option = zoomOption.intlData.map(item => (
                <Menu.Item value={item} key={item}>{
                    intl.formatMessage(
                        {
                            id: `Preferences.Content.pageDisplay.layoutAndZoom.zoom.options.${item}`
                        }
                    )
                }</Menu.Item>
            ));
            const option1 = zoomOption.data.map(item => (
                <Menu.Item value={item} key={item + '%'}>{item + '%'}</Menu.Item>
            ));
            return <Menu
                        style={{ height: '220px', overflowY: 'auto', boxShadow: 'rgb(0 0 0 / 15%) 0px 2px 8px' }}
                        onClick={me.selectZoomOption}>{option.concat(option1)}</Menu>;
        }
        return (
            <div className="preferences-page-display">
                <Form
                    labelCol={{ span: labelCol }}
                    wrapperCol={{
                        span: 10,
                        offset: 1
                    }}
                    name="pageDisplay"
                    size='small'>
                    <div className="title">{layoutAndZoomTitle}</div>
                    <div className="board LayoutGrid">
                        <Item label={navigationTabName} name="navigationTabName">
                            <Select
                                defaultValue={navigationTabOption.active}
                                onChange={this.handleChangeNavigation}>
                                {
                                    navigationTabOption.data.map(item => {
                                        return <Option value={item} key={item}>
                                            {
                                                intl.formatMessage(
                                                    {
                                                        id: `Preferences.Content.pageDisplay.layoutAndZoom.navigationTab.options.${item}`
                                                    }
                                                )
                                            }
                                        </Option>
                                    })
                                }
                            </Select>
                        </Item>
                        <Item label={defaultPageLayoutName} name="defaultPageLayoutName">
                            <Select
                                defaultValue={defaultPageLayoutOption.active}
                                onChange={this.handleChangDefaultPageLayout}>
                                {
                                    defaultPageLayoutOption.data.map(item => {
                                        return <Option value={item} key={item}>
                                            {
                                                intl.formatMessage(
                                                    {
                                                        id: `Preferences.Content.pageDisplay.layoutAndZoom.defaultPageLayout.options.${item}`
                                                    }
                                                )
                                            }
                                        </Option>
                                    })
                                }
                            </Select>
                        </Item>
                        <Item label={zoomOptionName} name="zoomOptionName" className="zoom-select">
                            <Dropdown.Button
                                className="dropdown-btn"
                                trigger={['click']}
                                overlay={dataSource}
                                icon={<DownOutlined />}
                                getPopupContainer={ () => document.getElementsByClassName('zoom-select')[0] }>
                                <Input
                                    value={zoomOption.value}
                                    onChange={this.changeZoom}
                                    onBlur={this.blurZoom} />
                            </Dropdown.Button>
                        </Item>
                        <Item
                            name="customFacingName"
                            className="custom-item"
                            label={
                                <Checkbox
                                    className="custom-label"
                                    checked={customFacingChecked}
                                    onChange={this.onChangeCustomFacing}>
                                    {customFacingName}
                                </Checkbox>
                            }>
                            <InputNumber
                                className="custom-input"
                                defaultValue={facingPages}
                                disabled={!customFacingChecked}
                                precision={0}
                                min={1}
                                max={99}
                                step={1}
                                onChange={this.onChangeFacingPages} />
                            <span className="suffix">
                                {
                                    intl.formatMessage({ id: 'Preferences.Content.pageDisplay.layoutAndZoom.customFacing.suffix' })
                                }
                            </span>
                        </Item>
                        <Item
                            name="customMarginName"
                            className="custom-item custom-margin"
                            label={
                                <Checkbox
                                    className="custom-label"
                                    checked={customMarginChecked}
                                    onChange={this.onChangeCustomMarginChecked}>
                                        {customMarginName}
                                </Checkbox>
                            }>
                            <InputNumber
                                className="custom-input"
                                defaultValue={margin}
                                disabled={!customMarginChecked}
                                min={0}
                                max={99}
                                step={1}
                                onChange={this.onChangeCustomMargin} />
                            <span className="suffix">
                                {
                                    intl.formatMessage({ id: 'Preferences.Content.pageDisplay.layoutAndZoom.customMargin.suffix' })
                                }
                            </span>
                        </Item>
                    </div>
                    <div className="title">{renderingTitle}</div>
                    <div className="board LayoutGrid">
                        <Item label={smoothTextName} name="smoothTextName">
                            <Select
                                defaultValue={smoothTextOption.active}
                                onChange={this.onChangSmoothText}>
                                {
                                    smoothTextOption.data.map(item => {
                                        return <Option value={item} key={item}>
                                            {
                                                intl.formatMessage(
                                                    {
                                                        id: `Preferences.Content.pageDisplay.rendering.smoothText.options.${item}`
                                                    }
                                                )
                                            }
                                        </Option>
                                    })
                                }
                            </Select>
                        </Item>
                        <Item
                            name="smoothLineArt"
                            wrapperCol={{ span: 24 }}
                            >
                                <Checkbox
                                    className="custom-label preference-page-display__row__first-item"
                                    checked={smoothLineArtChecked}
                                    onChange={this.onChangeSmoothLineArt}>{smoothLineArt}</Checkbox>
                                <Checkbox
                                    className="custom-label"
                                    checked={enhanceThinLinesChecked}
                                    onChange={e => this.setState({ enhanceThinLinesChecked: e.target.checked })}>{enhanceThinLinesText}</Checkbox>
                        </Item>
                    </div>
                    <div className="title">{pageContentTitle}</div>
                    <div className="board LayoutGrid">
                        <Item name="pageContent" wrapperCol={{ span: 24 }}>
                            <Checkbox
                                className="custom-label preference-page-display__row__first-item"
                                checked={transparencyGridChecked}
                                onChange={this.onChangeTransparencyGrid}>{transparencyGrid}</Checkbox>
                            <Checkbox
                                className="custom-label"
                                checked={logicalPageNumChecked}
                                onChange={this.onChangeLogicalPageNum}>{logicalPageNum}</Checkbox>
                        </Item>
                    </div>
                </Form>
            </div>
        );
    }
}